module.exports = __webpack_public_path__ + "static/img/current-screen.b9439530.svg";